<template>
  <header id="header">
    <div class="container"
         :style="{'box-shadow': show ? '0 0 50px rgba(0,0,0,.2)' : ''}">
      <div class="container-left">
        <a class="mobile-nav-btn pull-left navbar-toggle collapsed bg-img"
           href="javascript:void(0);"
           @click="show = !show"><em class="iconfont">&#xe618;</em>{{$t('home.menu')}}</a>
      </div>
      <div class="container-left-title hidden-md-my">
        <div class="title-right-logo">
          <h1>
            <a href="https://approvedplus.audi.com.hk" target="_self">
              <img src="../img/header_logo_1.png"
                   alt="Premium Motors Limited">
            </a>
          </h1>
        </div>
      </div>
      <div class="container-left container-left-nav">
        <el-collapse-transition>
          <div id="navbar"
               :class="['collapse','navbar-collapse', show ? 'in' : '', changeRed == 1 ? 'langTc' : '']"
               v-show="show"
               :style="{'box-shadow': show ? '0 10px 8px rgba(0,0,0,.1)' : ''}">
            <ul class="nav navbar-nav">
              <!-- <li v-for="(nav, index) in navList" :key="index" @click="show = false">
              <router-link :to="nav.url" :class="{active: nav.url === $route.path}" >{{nav.title}}</router-link>
            </li> -->
              <!-- <li @click="show = false">
              <router-link @click.native="goAnchor($t('navList[0].url'), 'one')" :to="$t('navList[0].url')" :class="{active: $t('navList[0].url') === $route.path}" >{{$t('navList[0].title')}}</router-link>
            </li> -->
              <li @click="show = false">
                <a ref="searchLi"
                   v-preventReClick="3000"
                   @click="goAnchor('/', null)"
                   :class="{active: $t('navList[1].url') === $route.path}"
                   v-scroll-to="{
                  el: el,
                  container: 'body',
                  duration: 300,
                  easing: 'ease',
                  offset: offset,
                  force: true,
                  cancelable: true,
                  onStart: false,
                  onDone: false,
                  onCancel: false,
                  x: false,
                  y: true
              }">{{$t('navList[1].title')}}</a>
              </li>
              <li @click="show = false">
                <router-link @click.native="goAnchor($t('navList[2].url'), 'on')"
                             :to="$t('navList[2].url')"
                             :class="{active: $t('navList[2].url') === $route.path}">{{$t('navList[2].title')}}<i v-if="$t('navList[2].i') == '' ? false : true">{{$t('navList[2].i')}}</i></router-link>
              </li>
              <li @click="show = false">
                <router-link @click.native="goAnchor($t('navList[3].url'), 'on')"
                             :to="$t('navList[3].url')"
                             :class="{active: $t('navList[3].url') === $route.path}">{{$t('navList[3].title')}}</router-link>
              </li>
              <li @click="show = false">
                <router-link @click.native="goAnchor($t('navList[4].url'), 'on')"
                             :to="$t('navList[4].url')"
                             :class="{active: $t('navList[4].url') === $route.path}">{{$t('navList[4].title')}}</router-link>
              </li>
              <li>
                <div class="langCol">
                  <div :class="['li', list.class, list.txt != $t('language.name') ? 'active' : '']"
                       v-for="(list, index) in languageList"
                       :key="index"
                       @click="changeLanguage(list.to, index)">{{list.txt}}</div>
                </div>
              </li>
            </ul>
          </div>
        </el-collapse-transition>
      </div>
      <div class="container-right">
        <div class="right-logo">
          <h2>
            <a>
              <img src="../img/header_logo_2.png"
                   alt="Audi"
                   class="hidden-xs">
              <img src="../img/header_logo_2.png"
                   alt="Audi"
                   class="visible-xs">
            </a>
          </h2>
        </div>
        <div class="title-right-logo visible-md-my">
          <h1>
            <a href="https://approvedplus.audi.com.hk" target="_self">
              <img src="../img/header_logo_mobile_1.png"
                   alt="Audi Approved :plus">
            </a>
          </h1>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import PubSub from 'pubsub-js'
export default {
  name: "Header",
  inject: ['reload'],
  data () {
    return {
      screenWidth: document.body.clientWidth,
      changeRed: 0,
      timer: false,
      show: false,
      offset: 0,
      current: '',
      // navList: [],
      languageList: [
        { id: 0, to: 'en', class: '', txt: 'ENG' },
        { id: 1, to: 'zh', class: 'langTc', txt: '中文' },
      ],
      on: null,
      el: '#search',
      showHome: false,
    };
  },
  mounted () {
    let that = this
    // that.navList = this.$t('navList')
    // that.navList = this.$t(' ')


    if (that.$t('language.name') != '中文') {
      that.changeRed = 1
    } else {
      that.changeRed = 0
    }

    // if (that.showHome == false) {
    //   that.el = '#sss'
    // }

    PubSub.subscribe('show', (msg, searchName) => {
      that.showHome = searchName
      that.el = '#search'
    })

    PubSub.subscribe('on', (msg, data) => {
      that.goAnchor(data.url, data.on)
    })

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    that.getscreenWidth()

  },
  methods: {
    changeLanguage (to, index) {

      this.$i18n.locale = to
      this.changeRed = index
      // this.$i18n.locale=='zh'?this.$i18n.locale='en':this.$i18n.locale='zh'   //设置中英文模式

      // localStorage.setItem('languageSet',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置

      this.$store.commit('$_setLocale', this.$i18n.locale)
      this.$router.push({ query: { lang: this.$i18n.locale } })

      // 发布消息
      PubSub.publish('locale', { locale: this.$i18n.locale })

      this.show = false
    },
    // 浏览器窗口大小
    getscreenWidth () {
      if (this.screenWidth >= 768) {
        this.show = false
      }
    },
    goAnchor (e, on) {
      if (e == 'search') {
        e = '/'
      } else {
        this.$router.push({ path: e })
      }
      if (on == 'one' && e == '/') {
        this.el = '#search'
        // if (this.showHome == false) {
        //   return this.el = '#sss'

        // } else {
        //   return this.el = '#search'
        // }
      }
      if (this.on == 'on' && e == '/') {
        // this.el = '#sss'
        this.offset = 500
        // this.$refs.searchLi.click()
        this.on = on
        setTimeout(() => {
          this.el = '#search'
          this.offset = 0
        }, 100)
      }
      this.on = on
    }
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.getscreenWidth()
          that.timer = false
        }, 200)
      }
    },
    showHome (val) {
      this.showHome = val
    }
  }
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
a {
  cursor: pointer;
}

/* header */
#header {
  // overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 99999;
  width: 100%;
  // height: 70px;
  background: #fff;
  // border-bottom: 1px solid rgba(0,0,0,0.3);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

  img {
    vertical-align: inherit;
  }

  .container-left {
    li {
      &:last-of-type {
        float: right;
      }

      .langCol {
        font-family: 'AudiTypeExtendedNormal', '微軟正黑體';
        height: 70px;
        line-height: 70px;
        font-weight: 400;
        padding: 0 14px;
        // color: #fff;
        color: #000;

        .li {
          // float: left;
          display: inline;
          font-family: 'AudiTypeExtendedBold', '微軟正黑體' !important;
          font-weight: 600;
          color: #000000;
          // line-height: 1.35;
          font-size: 14px;
          text-decoration: none;
          padding-right: 6px;
          border-right: 1px solid #000000;
          cursor: pointer;

          &.langTc {
            padding-left: 6px;
            padding-right: 0px;
            font-size: 14px;
            border-right: none;
          }

          &.active {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

#header .container {
  // padding-right: 0 !important;
  // padding-left: 0 !important;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}

#header .container-left {
  float: left;
}

#header .container-left-title {
  float: left;
}

/* nav */
#header .container-left {
  position: relative;
  height: 70px;
  // background-color: #000;
}

#header .container-left li a {
  font-family: 'AudiTypeExtendedNormal', '微軟正黑體';
  height: 70px;
  line-height: 70px;
  font-weight: 400;
  padding: 0 14px;
  // color: #fff;
  color: #000;
}

#header .container-left li i {
  font-family: 'AudiTypeExtendedNormal', '微軟正黑體';
}

#header .container-left li a.active, #header .container-left li a:hover, #header .container-left li a:focus {
  background-color: #eeeeee;
  // color: #000;
}

#header .container-left a.mobile-nav-btn {
  // background-image: url('../images/menu_icon.png');
  // width: 25px;
  // height: 23px;
  // margin: 8.5px 0 8.5px 15px;
  margin: 0;
  padding: 0;
  border: 0;
  // padding-left: 32px;
  background-size: auto 100%;
  line-height: 64px;
  color: #000;
  font-size: 11pt;
  text-decoration: none;

  em {
    font-size: 24px;
    position: absolute;
    left: 0;
    top: -2px;
  }
}

#header .container-left #navbar.collapse.in, #header .container-left #navbar.collapsing {
  position: absolute;
  left: 0;
  background-color: #fff;
  z-index: 99;
  width: 100%;
}

#header .container-left #navbar.langTc {
  font-size: 16px;

  li {
    a {
      // padding: 0 36px;
      padding: 0 48px;
    }
  }
}

#header .container-left #navbar.collapsing .nav.navbar-nav, #header .container-left #navbar.collapse.in .nav.navbar-nav {
  margin: 0 -15px;
}

#header .container-left #navbar.collapsing li a, #header .container-left #navbar.collapse.in li a {
  background-color: transparent;
  color: #000;
  border-bottom: 1px solid #ccc;
}

#header .container-right {
  float: right;
}

#header .title-right-logo, #header .title-right-logo h1, #header .right-logo, #header .right-logo h2 {
  line-height: 0 !important;
}

#header .title-right-logo h1, #header .right-logo h2 {
  margin: 0;
}

#header .title-right-logo {
  float: right;
  margin-right: 12px;
}

#header .right-logo {
  float: right;
}

#header .title-right-logo img {
  width: 160px;
  // height: 32px;
  // width: 138px;
  // height: 28px;
}

#header .right-logo img {
  width: 78px;
  height: 27px;
}

#header .title-right-logo a, #header .right-logo a {
  // display: inline-block;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 70px;
}

.container-left-nav {
  width: 870px;
}

.container-left-nav .navbar-nav {
  width: 100%;
}

.hidden-md-my {
  display: block;
}

.visible-md-my {
  display: none;
}

@media (max-width: 991px) {
  .hidden-md-my {
    display: none;
  }

  .visible-md-my {
    display: block;
  }

  #header {
    height: 60px;
  }

  #header .container-left {
    height: 60px;
    line-height: 60px;
  }

  #header .title-right-logo a, #header .right-logo a {
    height: 60px;
  }

  #header .container-left a.mobile-nav-btn {
    padding-left: 26px;
  }

  #header .title-right-logo, #header .title-right-logo h1, #header .right-logo, #header .right-logo h2 {
    line-height: 48px;
  }

  .container-left-nav {
    width: 100%;
    position: absolute !important;
    top: 60px !important;
    left: 0 !important;
    height: initial !important;
    line-height: normal !important;

    .navbar-nav {
      margin: 0 !important;
      border-top: 3px solid #fff;
    }

    li {
      a {
        padding: 15px 4% 13px !important;
        height: auto !important;
        line-height: normal !important;
      }
    }
  }

  .container-left {
    li {
      float: none !important;
      position: relative;
      display: block;

      .langCol {
        padding: 15px 4% 13px !important;
        height: auto !important;
        line-height: normal !important;

        .li {
          padding-right: 10px !important;

          &.langTc {
            padding-left: 10px !important;
          }
        }
      }
    }
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  #header .container-left #navbar {
    font-size: 13px;
  }

  #header .container-left li a {
    max-width: 158px;
    padding: 0px 9px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #header {
    .container-left {
      li {
        .langCol {
          // padding: 0 8px;
          .li {
            font-size: 13px;
          }
        }
      }

      #navbar.langTc {
        font-size: 15px;

        li {
          a {
            padding: 0 24px;
            max-width: 200px;
          }
        }
      }
    }

    .container-left-nav {
      width: 670px;
    }
  }
}

@media (min-width: 992px) {
  .container-left {
    display: none;
  }

  .container-left-nav {
    display: block;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .container-left-nav {
    width: 750px;
    margin-left: -375px;
    left: 50% !important;
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  }
}

@media (max-width: 768px) {
  #header .container {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }

  #header .title-right-logo {
    margin-right: 16px;
  }

  #header .title-right-logo img {
    width: 128px;
    // height: 28px;
  }

  #header .right-logo img {
    width: 72px;
    height: 25px;
  }

  .container-right .right-logo h2 a {
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue